import { render, staticRenderFns } from "./PrayerRequest.vue?vue&type=template&id=f52d0af0&"
import script from "./PrayerRequest.vue?vue&type=script&lang=js&"
export * from "./PrayerRequest.vue?vue&type=script&lang=js&"
import style0 from "./PrayerRequest.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports